
import { useModalStore } from "../../../stores/modalStore.js";
import PinnedMessagesPanel from "../PinnedMessagesPanel.jsx";

export function PinnedModal() {
  const { isOpen, type, onClose } = useModalStore();

  if (!isOpen || type !== "pinned") return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} style={{ width: "90%", maxWidth: 480 }}>
        <PinnedMessagesPanel />
      </div>
    </div>
  );
}
